module.exports = __webpack_public_path__ + "fonts/PingFangSC-SemiBold-simple.ab447e41.woff2";